import * as DropdownMenu from '@radix-ui/react-dropdown-menu'

import Button from 'common/components/button'
import { Sort } from 'common/icons'

import ImageSortMenu from './ImageSortMenu'

const ImageSort = () => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Button
          variant="icon"
          prefixIcon={<Sort isDefaultColor={false} size={6} />}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content sideOffset={4}>
          <ImageSortMenu />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

export default ImageSort
